module.exports = "/_next/static/images/a8bf525ed8c514c90679111f0bac39b8-roxinho-basicos-flutuantes-xs@2x.png.webp";